import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Reveal, MaskedLine } from "../components/Reveal";

export default function RecuperaPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 lg:py-32" data-testid="recupera-password-page">
      <div className="max-w-xl mx-auto">
        <MaskedLine delay={0.1}><span className="eyebrow">Accesso riservato</span></MaskedLine>
        <h1 className="mt-6 text-4xl sm:text-5xl leading-tight" data-testid="recupera-title">
          <MaskedLine delay={0.25}>Recupera la <em className="italic text-gold">password</em>.</MaskedLine>
        </h1>
        <Reveal delay={0.35}>
          <div className="mt-10 card-surface p-8 sm:p-10" data-testid="recupera-card">
            {sent ? (
              <div data-testid="recupera-success">
                <p className="font-serif text-2xl text-ink">Controlla la tua casella di posta.</p>
                <p className="mt-4 text-lg text-ink-muted leading-relaxed">
                  Se l'indirizzo è associato a un account attivo, riceverai un link per reimpostare la password.
                </p>
                <Link to="/accedi" className="btn-outline mt-8" data-testid="recupera-back">Torna all'accesso</Link>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-6" data-testid="recupera-form">
                <p className="text-base text-ink-muted leading-relaxed">
                  Inserisci l'email con cui hai richiesto l'accesso: ti invieremo un link per reimpostare la password.
                </p>
                <div>
                  <label htmlFor="rp-email" className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-muted mb-2">Email</label>
                  <input id="rp-email" type="email" className="input-field" required value={email}
                    onChange={(e) => setEmail(e.target.value)} data-testid="recupera-email" autoComplete="email" />
                </div>
                <button type="submit" className="btn-primary w-full disabled:opacity-60" disabled={busy} data-testid="recupera-submit">
                  {busy ? "Invio in corso…" : "Invia link di recupero"}
                </button>
                <Link to="/accedi" className="block text-center text-sm text-pine underline underline-offset-4 hover:text-gold" data-testid="recupera-back-link">
                  Torna all'accesso
                </Link>
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
